import useStore from "./useStore";

export default useStore;